// import * as Cookies from 'js-cookie'
import api from '../../js/api'
import createPersistedState from 'vuex-persistedstate'

var common = {
    plugins: [
        createPersistedState()
    ],
    state: {
        notificationId: localStorage.getItem('notificationId') || '',
        // customer_id: localStorage.getItem('customer_id') || '',
        token: localStorage.getItem('access_token') || '', //Token de autenticación
        name: localStorage.getItem('name') || '', //Nombre de la cuenta
        email: localStorage.getItem('email') || '',
        type: localStorage.getItem('type') || '', //Tipo de cuenta
        typeOrigin: localStorage.getItem('type_origin') || '', //Tipo de cuenta original (trainer,enterprise,student)
        cover: localStorage.getItem('cover') || '', //Portada de perfil
        avatar: localStorage.getItem('avatar') || '', //Foto de perfil
        active: localStorage.getItem('active') || '', //Activación de la cuenta
        accountActivated: localStorage.getItem('accountActivated') || '', //Activación de la cuenta heriberto
        notifyMessage: localStorage.getItem('message') || '',
        intro: null,


        //USER::
        jobsRecomendation: localStorage.getItem('jobsRecomendation') || 0,
        cursesRecomendation: localStorage.getItem('cursesRecomendation') || 0,


        navbar: true,
        error: false,
        errorMessage: null,
        loading: false,
        fromValidationSocial: false,
    },
    mutations: {

        login(state, data) { //Almacenamiento de información principal de usuario
            state.token = data.access_token

            let typeAccount = null
            if (data.user.type == 'student') {
                typeAccount = 'Usuario'
                state.name = data.user.name
                localStorage.setItem('name', data.user.name)

                state.accountActivated = true
                localStorage.setItem('accountActivated', true)

            } else if (data.user.type == 'trainer') {
                typeAccount = 'Capacitador'
                state.name = data.user.trainer_info.name_trainer
                localStorage.setItem('name', data.user.trainer_info.name_trainer)

                state.accountActivated = data.user.trainer_info.isValid
                localStorage.setItem('accountActivated', data.user.trainer_info.isValid)

            } else if (data.user.type = 'enterprise') {
                typeAccount = 'Empresa'
                state.name = data.user.enterprise_info.name
                localStorage.setItem('name', data.user.enterprise_info.name)

                state.accountActivated = data.user.enterprise_info.isValid
                localStorage.setItem('accountActivated', data.user.enterprise_info.isValid)
            }

            state.type = typeAccount
            state.typeOrigin = data.user.type
            state.cover = data.user.cover
            state.avatar = data.user.avatar
            state.email = data.user.email
            this.notificationId = data.user.id

            state.active = data.user.active
            localStorage.setItem('active', data.user.active)
            // localStorage.setItem('customer_id', data.user.customer_payment ? data.user.customer_payment.customer_id : '')

            localStorage.setItem('access_token', data.access_token)
            localStorage.setItem('type_origin', data.user.type)
            localStorage.setItem('email', data.user.email)
            localStorage.setItem('type', typeAccount)

            localStorage.setItem('notificationId', data.user.id)
            localStorage.setItem('cover', data.user.cover == 'cover.png' || data.user.cover == '' ? false : data.user.cover)
            localStorage.setItem('avatar', data.user.avatar == 'avatar.png' || data.user.avatar == '' ? false : data.user.avatar)
        },
        logout(state) {
            state.token = null
            state.name = null
            state.type = null
            state.typeOrigin = null
            state.cover = null
            state.avatar = null
            state.active = null
            state.email = null

            api.authorization(false, null) // delete axios.defaults.headers.common('Authorization')
            localStorage.clear()
        },
        avatar(state, src) {
            state.avatar = src
            localStorage.setItem('avatar', src)
        },
        intro(state, payload) {
            state.intro = payload
        },
        messageError(state, error) {
            state.error = !error.success
            state.errorMessage = error.message
        },
        loading(state, status) {
            state.loading = status
        },
        emailValid(state, status) {
            state.active = status === true
            localStorage.setItem('active', status === true)
        },
        notifyMessage(state, value) {
            if (value) {
                state.notifyMessage = true
                localStorage.setItem('message', true)
            } else {
                state.notifyMessage = false
                localStorage.removeItem('message')
            }
        },
        jobsRecomendation(state, value) {
            state.jobsRecomendation = value
            localStorage.setItem('jobsRecomendation', value)
        },
        cursesRecomendation(state, value) {
            state.cursesRecomendation = value
            localStorage.setItem('cursesRecomendation', value)
        },
        setValidationSocial(state, value) {
            state.fromValidationSocial = value
        }
    },
    actions: {
        authenticate({commit}, data) {
            //Función utilizada para la autenticación de los usuarios.
            api.authorization(true, data.access_token) //Establcemos la cabecera de autentication / token.
            commit('login', data) //Guardamos información en sesionStorage de los datos.
        },
        updateProfileAvatar({commit}, src) {
            commit('avatar', src)
        },
        updateIntro({commit}, intro) {
            commit('intro', intro)
        },
        emailValid({commit}, status) {
            commit('emailValid', status)
        },
        logout({commit}) { //Logout User
            return new Promise((resolve, reject) => {
                commit('logout')
                resolve()
            })
        },
        notifyMessage({commit}, value) { //MessageNotification
            commit('notifyMessage', value)
        },
        jobsRecomendation({commit}, value) {
            commit('jobsRecomendation', value)
        },
        cursesRecomendation({commit}, value) {
            commit('cursesRecomendation', value)
        }
    },
    getters: {
        //Principal Verification
        navbarView: state => state.navbar,
        avatar: state => state.avatar,
        intro: state => state.intro,
        cover: state => state.cover,
        type: state => state.type,
        typeOrigin: state => state.typeOrigin,
        active: state => eval(state.active),
        accountActivated: state => eval(state.accountActivated),
        email: state => state.email,
        isLoggedIn: state => !!state.token,
        notificationId: state => state.notificationId,
        notifyMessage: state => !!state.notifyMessage,

        jobsRecomendation: state => state.jobsRecomendation,
        cursesRecomendation: state => state.cursesRecomendation,


        //Login Modules Verify
        getToken: state => state.token,
        // authStatus: state => state.status,

        //Platform Data Errors
        errorInterface: state => state.error, //True - False (Show Error message?)
        errorInterfaceMessage: state => state.errorMessage, //Mensaje de error Login
        showLoading: state => state.loading, //True - False (Show Loading?)

        //UserProfileData
        userName: state => state.name,
        // userActivation: state => state.active,

        //EnterpriseData
        isEnterprise: state => !!state.userEnterpriseName,
        userEnterpriseName: state => state.userEnterpriseName,
        userEnterpriseUrl: state => state.userEnterpriseUrl,

        //TrainerData
        isTrainer: state => !!state.userTrainerName,
        userTrainerName: state => state.userTrainerName,
        userTrainerUrl: state => state.userTrainerUrl,
        getValidationSocial: state => state.fromValidationSocial

    }
}

export default common



// WEBPACK FOOTER //
// ./src/storage/modules/storage.js